import { ArrowRight } from 'lucide-react';

export function HighVisibilityPageHeader({ eyebrow, title, subtitle, countLabel, icon: Icon, actions, testId = 'high-visibility-page-header', titleTestId, tone = 'blue' }) {
  const gradients = {
    blue: 'from-[#2563EB] via-[#0EA5E9] to-[#14B8A6]',
    violet: 'from-[#7C3AED] via-[#2563EB] to-[#0EA5E9]',
    emerald: 'from-[#059669] via-[#0EA5E9] to-[#2563EB]',
  };
  return (
    <section className={`rounded-b-[1.75rem] bg-gradient-to-br ${gradients[tone] || gradients.blue} px-4 pb-5 pt-5 text-white shadow-lg sm:rounded-[1.5rem] sm:px-6`} data-testid={testId}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          {eyebrow && <p className="font-mono text-[10px] font-black uppercase tracking-[0.22em] text-white/75" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>}
          <h1 className="mt-1 text-4xl font-black leading-none tracking-tight font-heading sm:text-5xl" data-testid={titleTestId || `${testId}-title`}>{title}</h1>
          {subtitle && <p className="mt-2 text-base font-semibold text-white/90" data-testid={`${testId}-subtitle`}>{subtitle}</p>}
        </div>
        {Icon && <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/20 ring-1 ring-white/35" data-testid={`${testId}-icon`}><Icon className="h-7 w-7" /></div>}
      </div>
      {(countLabel || actions) && (
        <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          {countLabel && <div className="rounded-2xl bg-white/18 px-4 py-3 ring-1 ring-white/25" data-testid={`${testId}-count`}><p className="text-sm font-black">{countLabel}</p></div>}
          {actions && <div className="flex flex-wrap gap-2" data-testid={`${testId}-actions`}>{actions}</div>}
        </div>
      )}
    </section>
  );
}

export function HighVisibilityEmptyState({ icon: Icon, title, subtitle, action, testId = 'high-visibility-empty-state' }) {
  return (
    <div className="rounded-[1.75rem] border border-blue-100 bg-white p-8 text-center shadow-sm" data-testid={testId}>
      {Icon && <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-3xl bg-blue-50 text-blue-600"><Icon className="h-8 w-8" /></div>}
      <p className="text-xl font-black text-zinc-950 font-heading">{title}</p>
      {subtitle && <p className="mt-1 text-sm font-semibold text-zinc-500">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function HighVisibilityActionLink({ children, testId, className = '', ...props }) {
  return <a className={`inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-blue-600 px-4 text-sm font-black text-white transition-[transform,background-color] duration-150 hover:bg-blue-700 active:scale-95 ${className}`} data-testid={testId} {...props}>{children}<ArrowRight className="h-4 w-4" /></a>;
}